import { usePage } from '@inertiajs/react'
import BackToSchoolBanner from '@/Components/BackToSchoolBanner'
import LensCreditEventBanner from '@/Components/LensCreditEventBanner'

export default ({ blok }) => {
    const { component, props } = usePage()
    const promotions = props.settings?.promotions

    const lensCreditBanner = promotions?.lensCreditEvent?.active ? promotions.lensCreditEvent.banner : null

    // The lens credit group picked in the admin fronts the home page while it runs;
    // Back to School takes the strip when no group is set to show.
    if (component === 'Home' && lensCreditBanner) {
        return <LensCreditEventBanner group={lensCreditBanner} />
    }

    if (component === 'Home' && promotions?.backToSchool?.active) {
        return <BackToSchoolBanner />
    }

    const href = blok.link?.url || blok.link?.cached_url || '/glasses'

    return (
        <a href={href} className={blok.class}>
            {blok.title}
        </a>
    )
}
